/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ShareAudience = zod
  .enum(['USER', 'GROUP', 'GROUP_MEMBERS', 'PUBLIC'])
  .describe(
    'Who the grant is for: one person (USER), a group acting as itself (GROUP), everyone in a group (GROUP_MEMBERS), or everyone (PUBLIC).',
  );

export type ShareAudience = zod.input<typeof ShareAudience>;
export type ShareAudienceOutput = zod.output<typeof ShareAudience>;
